import React from 'react';
interface BadgeProps {
  variant?: 'success' | 'warning' | 'danger' | 'neutral' | 'info';
  children: React.ReactNode;
  className?: string;
}
export function Badge({
  variant = 'neutral',
  children,
  className = ''
}: BadgeProps) {
  const variants = {
    success: 'bg-[#e8f0e5] text-[#4a7340] border-[#639754]',
    warning: 'bg-[#fff9db] text-[#5c4d00] border-[#FFD301]',
    danger: 'bg-[#fce8e7] text-[#5c1a17] border-[#E03C32]',
    neutral: 'bg-gray-100 text-gray-800 border-gray-200',
    info: 'bg-blue-100 text-blue-800 border-blue-200'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variants[variant]} ${className}`} data-id="element-158">
      {children}
    </span>;
}